module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-11.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-11.png
// module id = 1386
// module chunks = 0